import { 
  Code, 
  Server, 
  Database, 
  Palette, 
  Globe 
} from 'lucide-react';
import React from 'react';
import { Project, Skill, Experience } from '../types';

export const projects: Project[] = [
    {
    id: 1,
    title: "LoL Tracker",
    description: "Application web regroupant les statistiques du monde compétitif de League of Legends créée pour ma soutenance de Bachelor",
    stack: ["React", "Node.js", "JavaScript", "HTML/CSS"],
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
    category: "fullstack"
  },
  {
    id: 2,
    title: "Site d'Anecdotes",
    description: "Site web où les utilisateurs partagent et consultent des anecdotes entre utilisateurs avec une interface utilisateur intuitive",
    stack: ["React", "JavaScript", "HTML/CSS", "Node.js"],
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop",
    category: "frontend"
  },
    {
    id: 3,
    title: "Participation au développement de SafeHub",
    description: "Développement de fonctionnalités React pour améliorer l'expérience utilisateur et optimisation du design",
    stack: ["React", "JavaScript", "HTML/CSS", "UX/UI"],
    image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&h=400&fit=crop",
    category: "fullstack"
  },
  {
    id: 4,
    title: "Site E-sport",
    description: "Projet de fin de BTS SIO - Site listant les joueurs d'un jeu en ligne avec base de données MySQL",
    stack: ["PHP", "HTML5", "CSS3", "JavaScript", "MySQL"],
    image: "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=600&h=400&fit=crop",
    category: "fullstack"
  },
  {
    id: 5,
    title: "Site E-commerce CAUMONT LLC",
    description: "Site e-commerce avec intégration de paiements, optimisation UX/UI et gestion de contenu SEO",
    stack: ["HTML/CSS", "JavaScript", "PHP", "MySQL"],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop",
    category: "frontend"
  },
  {
    id: 6,
    title: "Site vitrine chez Jalya Studio",
    description: "Développement de sites vitrines via des plateformes low-code/no-code avec tests et déploiement",
    stack: ["JavaScript", "HTML/CSS", "Low-Code", "PHP "],
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=600&h=400&fit=crop",
    category: "fullstack"
  },
];

export const skills: Skill[] = [
  { 
    name: "HTML/CSS", 
    icon: React.createElement(Globe), 
    level: 90, 
    category: "frontend" 
  },
  { 
    name: "JavaScript", 
    icon: React.createElement(Code), 
    level: 80, 
    category: "frontend" 
  },
  { 
    name: "UX/UI Design", 
    icon: React.createElement(Palette), 
    level: 80, 
    category: "design" 
  },
  { 
    name: "MySQL", 
    icon: React.createElement(Database), 
    level: 80, 
    category: "database" 
  },
  { 
    name: "SQL", 
    icon: React.createElement(Database), 
    level: 70, 
    category: "database" 
  },
  { 
    name: "PHP", 
    icon: React.createElement(Server), 
    level: 75, 
    category: "backend" 
  },
  { 
    name: "Python", 
    icon: React.createElement(Server), 
    level: 60, 
    category: "backend" 
  },
  { 
    name: "React", 
    icon: React.createElement(Code), 
    level: 50, 
    category: "frontend" 
  },
  { 
    name: "Java", 
    icon: React.createElement(Server), 
    level: 40, 
    category: "backend" 
  },
];

export const experiences: Experience[] = [
  {
    id: 1,
    title: "Développeur Front-End (React)",
    company: "SafeHub",
    period: "Avril 2025 - Juillet 2025",
    description: "Développement de fonctionnalités avec React pour améliorer l'expérience utilisateur et optimisation du design de l'interface pour une navigation fluide.",
    technologies: ["React", "JavaScript", "HTML/CSS", "UX/UI Design"]
  },
  {
    id: 2,
    title: "Développeur Web",
    company: "Jalya Studio",
    period: "Février 2025 - Avril 2025",
    description: "Développement d'applications web et mobiles via des plateformes low-code/no-code. Tests, déploiement et ajustements en fonction des retours utilisateurs.",
    technologies: ["JavaScript", "HTML/CSS", "Low-Code/No-Code", "Tests"]
  },
  {
    id: 3,
    title: "Développeur Web Full Stack",
    company: "SOLREV",
    period: "Janvier 2024 - Février 2024",
    description: "Implémentation de fonctionnalités web (Front-end et Back-end). Co-conception et création d'une nouvelle application web. Debugging et optimisation des performances.",
    technologies: ["React", "Node.js", "JavaScript", "HTML/CSS", "Debugging"]
  },
  {
    id: 4,
    title: "Développeur Web",
    company: "CAUMONT LLC",
    period: "Mai 2023 - Juin 2023",
    description: "Réalisation d'un site e-commerce avec intégration de paiements et optimisation UX/UI. Gestion de contenu SEO pour améliorer la visibilité.",
    technologies: ["HTML/CSS", "JavaScript", "PHP", "E-commerce", "SEO"]
  }
];